export function qrcode(ctx) {
    return {
        styles: {
            main: { bg_opa: 255 },
        },
    };
}
